import { ComunicatorTemplatesView } from "@/pages/ComunicatorPage";

export default function ComMailTemplatesPage() {
  return (
    <div>
      <div className="sw-page-title">
        <h1>✉ Modelli Mail</h1>
        <div className="sw-breadcrumb">Home &gt; Modelli Mail</div>
      </div>
      <ComunicatorTemplatesView />
    </div>
  );
}
